export const gitCommit = '5e01795c'
